"use strict";

angular.module("vendor")
.controller("ModifySalesRepresentativeUserPasswordModalController", function(
    $scope, $attrs, close, FormError
) {
    $scope.form = {};
    $scope.title = $attrs.title;

    $scope.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    $scope.confirm = function() {
        $scope.modifyPasswordForm.$setSubmitted();
        FormError.focus("modifyPasswordForm");
        if ($scope.modifyPasswordForm.$valid) {
            $scope.close($scope.form.newPassword);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/modals/modify-sales-representative-user-password.modal.js
// module id = 1000
// module chunks = 0